export default {
  // Store dashboard_data state
  FETCH_DASHBOARD_DATA: "FETCH_DASHBOARD_DATA",
};
